import React from "react";
import { Plus } from "lucide-react";

import BottomSheet from "../UX/BottomSheet";
import { formatRecipientName } from "../../utils/letterBoard";
import { recipientReceivedRingClass } from "../../utils/letterSend";

function LetterRecipientsSheet({
  open,
  onClose,
  recipients,
  onAddRecipient,
  onEditRecipient,
  readOnly = false,
}) {
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Destinataires"
      footer={
        !readOnly && (
          <button
            type="button"
            onClick={() => {
              onClose();
              onAddRecipient();
            }}
            className="flex w-full items-center justify-center gap-2 rounded-md bg-primaryDark py-3.5 font-josefin text-sm font-medium text-white transition hover:bg-primaryText"
          >
            <Plus size={18} />
            Destinataire
          </button>
        )
      }
    >
      {recipients.length === 0 ? (
        <p className="py-6 text-center font-josefin text-sm italic text-textMuted">
          Aucun destinataire pour le moment.
        </p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {recipients.map((recipient) =>
            readOnly ? (
              <span
                key={recipient._id}
                className={`rounded-md bg-modalSage px-4 py-2.5 font-josefin text-sm font-medium text-white ${recipientReceivedRingClass(recipient, "dark")}`}
              >
                {formatRecipientName(recipient)}
              </span>
            ) : (
              <button
                key={recipient._id}
                type="button"
                onClick={() => {
                  onClose();
                  onEditRecipient(recipient._id);
                }}
                className={`rounded-md bg-sageDark px-4 py-2.5 font-josefin text-sm font-medium text-white transition hover:bg-modalSage ${recipientReceivedRingClass(recipient, "dark")}`}
              >
                {formatRecipientName(recipient)}
              </button>
            )
          )}
        </div>
      )}
    </BottomSheet>
  );
}

export default LetterRecipientsSheet;
